module.exports = __webpack_public_path__ + "img/1717724571263-WhatsApp Image 2024-06-07 at 09.23.35 1.jpeg.cd34017d.webp";